<script setup lang="ts">
import { Bot } from 'lucide-vue-next'
import { useAiChatStore } from '@/stores/aiChat'

const aiStore = useAiChatStore()
</script>

<template>
  <button
    @click="aiStore.toggle()"
    class="fixed bottom-6 right-24 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-violet-600 hover:bg-violet-500 text-white shadow-lg transition-colors"
    title="Ask Vigilante"
  >
    <Bot class="w-6 h-6" />
    <span
      v-if="aiStore.isSending"
      class="absolute -top-1 -right-1 flex h-4 w-4"
    >
      <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-violet-400 opacity-75"></span>
      <span class="relative inline-flex rounded-full h-4 w-4 bg-violet-500"></span>
    </span>
  </button>
</template>
